import { axiosInstance } from '@/lib/axios'
import { ForeignAmountsPreviewQuery, ForeignAmountsPreviewOutput } from './types'
import { formatDate } from '@/modules/shared/utils/date'

const prepareDate = (date: ForeignAmountsPreviewQuery['yearMonth']): string => {
  const _date =
    typeof date === 'number' || typeof date === 'string' ? new Date(date) : date
  return formatDate(_date, 'YYYY-MM-DD')
}

export function getForeignAmountsPreview({
  companyId,
  driverId,
  yearMonth,
}: ForeignAmountsPreviewQuery) {
  return axiosInstance.get<ForeignAmountsPreviewOutput>(
    `/api/${companyId}/timesheet/foreignAmounts`,
    {
      params: {
        driverId,
        date: prepareDate(yearMonth),
      },
    },
  )
}
